export default __webpack_public_path__ + "static/media/c9a1160969f6c2b2d921207577b563a11581602205552.6bc33cf6.webp";